<template>
  <v-row class="pollform match-height">
    <v-col cols="12">
      <v-card>
        <v-card-title>{{ $t("Kyselyt") }}</v-card-title>
        <v-card-text>
          <poll-form v-if="pollId || isNew" :poll_type="1" :id="pollId"></poll-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { onMounted, ref } from "vue-demi";
import pollForm from "./components/pollform.vue";
import { useTranslations } from "@/@core/libs/i18n";

export default {
  components: {
    pollForm,
  },
  props: ["poll_type", "id"],
  setup(props) {
    const pollId = ref(null);
    const isNew = ref(false);

    onMounted(() => {
      if (props.id) {
        pollId.value = props.id;
      } else {
        isNew.value = true;
      }
    });

    return {
      pollId,
      isNew,
    };
  },
};
</script>

<style></style>